module.exports = __webpack_public_path__ + "img/animals_tiger.880cbd35.png";